/**
 * TanStack Query hooks for `kpi-instructions`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	kpiInstructionsQueryKeys,
	type CreateKpiInstructionsBody,
	type ListKpiInstructionsResponse,
	type KpiInstructionsRow,
} from "./api";

export function useKpiInstructionsList(): UseQueryResult<ListKpiInstructionsResponse, Error> {
	return useQuery({
		queryKey: kpiInstructionsQueryKeys.list(),
		queryFn: list,
	});
}

export function useKpiInstructionsCreate(): UseMutationResult<KpiInstructionsRow, Error, CreateKpiInstructionsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kpiInstructionsQueryKeys.all });
		},
	});
}

export function useKpiInstructionsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: kpiInstructionsQueryKeys.all });
		},
	});
}
